import { useState } from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';

import parallaxImg from '../imagesForCategory/Wedding/Wed 06.jpg';

const branches = [
  {
    name: 'Main Branch',
    brand: 'Sabitha Citi Studio',
    address: 'C-18, First Floor, Green Square Plaza, Opp. Public Gardens, Hanamkonda - 506001',
    phone: '+91-9703377033',
    phone2: '+91-9849404700',
    mapQuery: 'Sabitha+Citi+Studio+Green+Square+Plaza+Hanamkonda',
  },
  {
    name: 'Branch 2',
    brand: 'Sabitha Studio',
    address: 'Near WIN Motors, Srinivasa Colony, Erragattugutta, Beemaram, Hasanparthy, Hanamkonda - 506015',
    phone: '+91-9703355033',
    phone2: null,
    mapQuery: 'Sabitha+Studio+Srinivasa+Colony+Hasanparthy+Hanamkonda',
  },
  {
    name: 'Branch 3',
    brand: 'Sabitha Studio',
    address: '10-30/A, Near Bus Stop, Kamalapur, Hanamkonda - 505102',
    phone: '+91-9440111443',
    phone2: null,
    mapQuery: 'Sabitha+Studio+Kamalapur+Hanamkonda',
  },
];

const enquiryServices = [
  'Wedding Photography & Videography',
  'Pre-Wedding Shoot',
  'Maternity Shoot',
  'Newborn / Baby Photography',
  '1st Birthday / Pre-Birthday',
  'Haldi / Mehendi / Sangeet',
  'Bridal & Groom Ceremony',
  'Saree Ceremony',
  'Wedding Anniversary',
  'Family Photography',
  'Portraits & Passport Photos',
  'Other',
];

export default function Contact() {
  useScrollAnimation();

  const [form, setForm] = useState({ name: '', phone: '', service: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `Hi Sabitha Studio!%0A%0AName: ${form.name}%0APhone: ${form.phone}%0AService: ${form.service}%0AMessage: ${form.message}`;
    window.open(`https://wa.me/919703377033?text=${message}`, '_blank');
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
  };

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <main>
      {/* ═══ QUICK CONTACT BAR ═══ */}
      <section className="bg-charcoal-light border-y border-gold/8">
        <div className="max-w-5xl mx-auto px-4 py-6 flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-12">
          <a href="tel:+919703377033" className="flex items-center gap-3 text-cream/70 hover:text-gold transition-colors group">
            <svg className="w-5 h-5 text-gold" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
              <path d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
            </svg>
            <span className="text-sm font-montserrat">+91-9703377033</span>
          </a>
          <a href="tel:+919849404700" className="flex items-center gap-3 text-cream/70 hover:text-gold transition-colors">
            <svg className="w-5 h-5 text-gold" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
              <path d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
            </svg>
            <span className="text-sm font-montserrat">+91-9849404700</span>
          </a>
          <a
            href="https://wa.me/919703377033"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 text-cream/70 hover:text-gold transition-colors"
          >
            <svg className="w-5 h-5 text-gold" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
            <span className="text-sm font-montserrat">WhatsApp</span>
          </a>
        </div>
      </section>

      {/* ═══ BRANCHES + ENQUIRY FORM ═══ */}
      <section className="py-28 md:py-36 bg-charcoal">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-5 gap-16">
            {/* Left — Branches */}
            <div className="lg:col-span-3">
              <div className="fade-up mb-12">
                <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-3">Visit Us</p>
                <h2 className="font-playfair text-3xl md:text-4xl text-cream mb-4">
                  Our <span className="italic text-gold">Branches</span>
                </h2>
                <div className="gold-line-left" />
              </div>

              <div className="space-y-8 stagger">
                {branches.map((branch, i) => (
                  <div key={i} className="fade-up p-8 border border-gold/8 rounded hover:border-gold/20 transition-colors duration-500 group">
                    <div className="flex items-start justify-between mb-4">
                      <div>
                        <h3 className="font-playfair text-xl text-gold mb-1">{branch.name}</h3>
                        <p className="text-cream/40 text-[10px] tracking-[0.15em] uppercase font-montserrat">{branch.brand}</p>
                      </div>
                      {i === 0 && (
                        <span className="text-[9px] tracking-[0.15em] uppercase font-montserrat text-gold bg-gold/10 px-3 py-1 rounded">
                          Headquarters
                        </span>
                      )}
                    </div>

                    <div className="flex items-start gap-3 mb-4">
                      <svg className="w-4 h-4 text-gold mt-0.5 shrink-0" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                        <path d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                      </svg>
                      <p className="text-cream/55 text-sm leading-relaxed">{branch.address}</p>
                    </div>

                    <div className="flex flex-wrap gap-4">
                      <a href={`tel:${branch.phone.replace(/-/g, '')}`} className="flex items-center gap-2 text-cream/65 text-sm hover:text-gold transition-colors">
                        <svg className="w-3.5 h-3.5 text-gold" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                          <path d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                        </svg>
                        {branch.phone}
                      </a>
                      {branch.phone2 && (
                        <a href={`tel:${branch.phone2.replace(/-/g, '')}`} className="flex items-center gap-2 text-cream/65 text-sm hover:text-gold transition-colors">
                          <svg className="w-3.5 h-3.5 text-gold" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                            <path d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                          </svg>
                          {branch.phone2}
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right — Enquiry Form */}
            <div className="lg:col-span-2">
              <div className="fade-right sticky top-36">
                <div className="p-8 md:p-10 bg-charcoal-light border border-gold/10 rounded">
                  <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-2">Quotation Enquiry</p>
                  <h3 className="font-playfair text-2xl text-cream mb-6">
                    Send Us a <span className="italic text-gold">Message</span>
                  </h3>
                  <div className="gold-line-left mb-8" />

                  {submitted ? (
                    <div className="text-center py-12">
                      <svg className="w-12 h-12 text-gold mx-auto mb-4" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <p className="text-cream font-playfair text-lg mb-2">Opening WhatsApp...</p>
                      <p className="text-cream/50 text-sm">Your message is ready to send!</p>
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit} className="space-y-5">
                      <div>
                        <label className="text-cream/50 text-[10px] tracking-[0.15em] uppercase font-montserrat block mb-2">Your Name</label>
                        <input
                          type="text"
                          name="name"
                          required
                          value={form.name}
                          onChange={handleChange}
                          className="w-full bg-charcoal border border-gold/10 rounded px-4 py-3 text-cream text-sm font-light focus:border-gold/40 focus:outline-none transition-colors placeholder-cream/20"
                          placeholder="Enter your name"
                        />
                      </div>
                      <div>
                        <label className="text-cream/50 text-[10px] tracking-[0.15em] uppercase font-montserrat block mb-2">Phone Number</label>
                        <input
                          type="tel"
                          name="phone"
                          required
                          value={form.phone}
                          onChange={handleChange}
                          className="w-full bg-charcoal border border-gold/10 rounded px-4 py-3 text-cream text-sm font-light focus:border-gold/40 focus:outline-none transition-colors placeholder-cream/20"
                          placeholder="+91-XXXXXXXXXX"
                        />
                      </div>
                      <div>
                        <label className="text-cream/50 text-[10px] tracking-[0.15em] uppercase font-montserrat block mb-2">Service Needed</label>
                        <select
                          name="service"
                          required
                          value={form.service}
                          onChange={handleChange}
                          className="w-full bg-charcoal border border-gold/10 rounded px-4 py-3 text-cream text-sm font-light focus:border-gold/40 focus:outline-none transition-colors appearance-none cursor-pointer"
                        >
                          <option value="" className="bg-charcoal">Select a service</option>
                          {enquiryServices.map((s) => (
                            <option key={s} value={s} className="bg-charcoal">{s}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="text-cream/50 text-[10px] tracking-[0.15em] uppercase font-montserrat block mb-2">Message (Optional)</label>
                        <textarea
                          name="message"
                          rows="3"
                          value={form.message}
                          onChange={handleChange}
                          className="w-full bg-charcoal border border-gold/10 rounded px-4 py-3 text-cream text-sm font-light focus:border-gold/40 focus:outline-none transition-colors resize-none placeholder-cream/20"
                          placeholder="Tell us about your event, dates, requirements..."
                        />
                      </div>
                      <button type="submit" className="btn-gold w-full text-center">
                        Send via WhatsApp
                      </button>
                      <p className="text-cream/30 text-[10px] text-center">
                        This will open WhatsApp with your message pre-filled
                      </p>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="section-divider" />

      {/* ═══ PARALLAX CTA ═══ */}
      <section
        className="parallax-section py-28 md:py-36"
        style={{ backgroundImage: `url(${parallaxImg})` }}
      >
        <div className="max-w-4xl mx-auto px-4 text-center fade-up">
          <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-4">We're Here For You</p>
          <h2 className="font-playfair text-4xl md:text-5xl text-cream mb-10">
            Walk In or <span className="italic text-gold">Call Anytime</span>
          </h2>
          <p className="text-cream/70 text-xl md:text-2xl leading-[1.8] font-light font-cormorant italic mb-8">
            "Whether you want a portrait, a passport photo, or complete wedding coverage —
            we are always just a call away."
          </p>
          <div className="gold-line mb-10" />
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:+919703377033" className="btn-gold">Call +91-9703377033</a>
            <a href="https://wa.me/919703377033" target="_blank" rel="noopener noreferrer" className="btn-outline">WhatsApp Us</a>
          </div>
        </div>
      </section>
    </main>
  );
}
